import React, { useEffect, useRef } from "react";

// Renders a Google AdSense ad unit for publisher ca-pub-8269502994906394. The
// global adsbygoogle loader script already lives in public/index.html, so it is
// NOT duplicated here — this only outputs the <ins> unit and runs the push once.
// Responsive by default. Pass slot/format to render a specific unit:
//   Horizontal:  <AdUnit slot="2429237617" format="auto" fullWidthResponsive />
//   Multiplex:   <AdUnit slot="9922293832" format="autorelaxed" />
export function AdUnit({
  slot = "2429237617",
  format = "auto",
  fullWidthResponsive = true,
  className = "",
}) {
  const pushed = useRef(false);

  useEffect(() => {
    if (pushed.current) return;
    pushed.current = true;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      /* adsbygoogle not ready yet — the loader will process the slot when it loads */
    }
  }, []);

  const insProps = {
    className: "adsbygoogle",
    style: { display: "block" },
    "data-ad-client": "ca-pub-8269502994906394",
    "data-ad-slot": slot,
    "data-ad-format": format,
  };
  // autorelaxed (Multiplex) units must not carry full-width-responsive.
  if (format !== "autorelaxed") insProps["data-full-width-responsive"] = fullWidthResponsive ? "true" : "false";

  return (
    <div className={`mx-auto w-full max-w-5xl px-4 ${className}`} data-testid={`ad-unit-${slot}`}>
      <ins {...insProps} />
    </div>
  );
}
